import { useEffect, useMemo } from 'react';
import { CLIENT_BASE_URL } from '../../../../constants';

export default function ExternalAuth({
  location,
}: {
  location: Location;
}): null {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const windowLocation = useMemo(() => location, []);

  const queryParams = new URLSearchParams(
    windowLocation.hash.replace('#', '?')
  );

  useEffect(function externalAuthHandler() {
    const accessToken = queryParams.get('access_token');
    const error = queryParams.get('error');

    (window.opener as typeof window)?.postMessage(
      {
        type: 'external-auth',
        accessToken,
        error:
          error ??
          (accessToken == null
            ? 'Authentication failed with external service.'
            : undefined),
      },
      CLIENT_BASE_URL
    );
    window.close();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
}
